import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsLanguagePopupOpened, setLanguage } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import LanguageRow from './items/LanguageRow';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import CancelButton from '../../../general/inputs/CancelButton';

const Language: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { consultationId } = useParams();
    const colors = useAppSelector(state => state.theme.colors);
    
    // This popup uses the language from the specific consultation's state
    const language = useAppSelector(state => state.consultation.language);

    const handleLanguage = async (selectedLanguageCode: string) => {
        const content = { consultationId, language: selectedLanguageCode };
        updateConsultation(content);
        dispatch(setLanguage(selectedLanguageCode));
        i18n.changeLanguage(selectedLanguageCode);
        dispatch(setNotificationMessage(t('languageUpdated')));
        dispatch(setIsLanguagePopupOpened(false));
    };

    const handleQuit = () => {
        dispatch(setIsLanguagePopupOpened(false));
    };

    return (
        <Box onClick={handleQuit} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', backgroundColor: colors?.popup, overflow: 'hidden', position: 'absolute', zIndex: 100000000 }}>
            <Box onClick={(e) => e.stopPropagation()} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', textAlign: 'center', maxWidth: isMobile ? '90vw' : '400px', width: '100%', padding: isMobile ? 2 : 3, borderRadius: 4, fontSize: 14, backgroundColor: colors?.container }}>
                <Box sx={{ width: '100%', fontSize: 18, marginBottom: isMobile ? 2 : 3 }}>
                    {t('selectLanguage')}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', maxHeight: '30vh', overflowX: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none' }}>
                    <LanguageRow
                        icon={<PublicOutlinedIcon />}
                        title={'fr'}
                        handler={() => handleLanguage('fr')}
                        isActive={language === 'fr'} // Pass the correct boolean
                    />
                    <LanguageRow
                        icon={<PublicOutlinedIcon />}
                        title={'en'}
                        handler={() => handleLanguage('en')}
                        isActive={language === 'en'} // Pass the correct boolean
                    />
                </Box>
            </Box>
            <CancelButton handler={handleQuit} />
        </Box>
    );
};

export default Language;